import uuidV4 from 'uuid/v4';
import get from 'lodash/get';
import { INITIALIZE_TROVIT, UPDATE_TROVIT, SET_QUERY_TROVIT } from './constants';
import {
  LOCATION_CHANGE,
  ENABLE_TRACKING_IMPRESSIONS,
  DISABLE_TRACKING_IMPRESSIONS,
} from '../tracking/constants';
import defaultState from '../state';

const trovitInitialState = defaultState.trovit;

export default (state = trovitInitialState, action) => {
  switch (action.type) {
    case INITIALIZE_TROVIT: {
      return {
        ...state,
        installationId: action.data.installationId,
        query: action.data.query,
        url: action.data.url,
        userCampaignIds: action.data.userCampaignIds && action.data.userCampaignIds,
        origin: action.data.origin,
        trackingCodes: action.data.trackingCodes,
        sendingId: action.data.sendingId,
        userAgent: action.data.userAgent,
        userIp: action.data.userIp,
        device: action.data.device,
        pageviewId: uuidV4(),
        abTest: action.data.abTest,
        publishYourCv: action.data.publishYourCv,
        imagePlaceHolders: action.data.imagePlaceHolders,
        host: action.data.host,
        bot: action.data.bot,
      };
    }

    case UPDATE_TROVIT: {
      return { ...state, query: { ...get(state, 'query'), statusCode: action.data.statusCode } };
    }

    case LOCATION_CHANGE: {
      const query = action.data.query;
      query.statusCode = action.data.statusCode;
      return {
        ...state,
        previousUrl: state.url,
        url: action.data.url,
        query,
        pageviewId: uuidV4(),
      };
    }

    case SET_QUERY_TROVIT: {
      return { ...state, query: action.data.query };
    }

    case ENABLE_TRACKING_IMPRESSIONS:
      return { ...state, canTriggerTrackingImpressions: true };

    case DISABLE_TRACKING_IMPRESSIONS:
      return { ...state, canTriggerTrackingImpressions: false };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/Index/reducerTrovit.js